module.exports = __webpack_public_path__ + "img/borderCardWhite.496f830f.svg";